import React from "react";
import Layout from "./Layout";

const IntegrationGuidelines = () => {
  return (
    <Layout>
      <div className="p-4 bg-white rounded shadow">
        <h2 className="text-lg font-semibold mb-4">Integration Guidelines</h2>
        <ul className="list-disc pl-6 text-gray-800">
          <li>
            Ensure all controlled substances are logged as per legal
            requirements.
          </li>
          <li>
            Retain prescriptions for Schedule H, H1, and X drugs as specified.
          </li>
          <li>Maintain separate registers for Schedule X drugs.</li>
          <li>Label storage areas clearly for restricted drugs.</li>
          <li>
            Automate reminders for regulatory deadlines (e.g., annual returns).
          </li>
        </ul>
      </div>
    </Layout>
  );
};

export default IntegrationGuidelines;
